import { render } from "./DaycareClassDetail.vue?vue&type=template&id=08af6da8&ts=true"
import script from "./DaycareClassDetail.vue?vue&type=script&lang=ts"
export * from "./DaycareClassDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__